import React from 'react';
import ScrollToTop from '../components/ScrollToTop';
import Unsubscribe from '../components/Unsubscribe';

function UnsubscribePage() {
  return (
    <>
      <ScrollToTop />
      <Unsubscribe />
    </>
  );
}

export default UnsubscribePage;
